import { ref } from 'vue'
import { pointeuseService } from '../../services/pointeuseService.js'

/**
 * Le nombre d'anomalies « à relancer », partagé par la pastille du menu et le
 * compteur de l'onglet « À traiter ». Un seul état pour toute l'application :
 * une relance ou un classement le relit, et les deux affichages suivent.
 * `null` tant qu'il n'est pas connu (zéro serait une affirmation).
 */
const count = ref(null)
let sequence = 0

export async function refreshPointeuseToTreatCount() {
  const current = ++sequence
  try {
    const result = await pointeuseService.getToTreatCount()
    if (current === sequence) count.value = Number(result?.aRelancer) || 0
  } catch (error) {
    console.error('Erreur de lecture du nombre d’anomalies de la pointeuse :', error)
  }
}

export function usePointeuseToTreatCount() {
  return { count, refresh: refreshPointeuseToTreatCount }
}
